var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.conversationId !== -1)?_c('div',{staticClass:"chatbot-conversation-status"},[_c('p',[_vm._v(_vm._s('Estado conversacion: ' + _vm.getLabelForCurrentConversationStatus))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }